import { useMutation } from 'react-query';

import { postComment } from 'services/messages';

export default function usePostComment() {
  const mutation = useMutation({
    mutationFn: postComment,
  });

  return mutation;
}
